import { FormControl, InputBase, List, MenuItem, Select, Stack, Typography, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { useLayoutEffect, useRef, useState } from 'react';
import getActionMarcarNaoLido from 'src/actions/chats/getActionMarcarNaoLido';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import {
  getChatsAtendimento,
  setSelectedMessage,
  getCountsChats,
  getMensagensWhatsappDb,
  getMensagensMetaDb,
  setChatInfo,
  resetMensagensEnviar,
  setPushChatList,
  updateChatList,
} from 'src/redux/slices/chat';
import { useDispatch, useSelector } from 'src/redux/store';
import ChatAtendimentoItem from 'src/sections/@chats/chat/ChatsListItem/ChatAtendimentoItem';
import Iconify from 'src/components/Iconify';
import v2_actionFinalizarMultiplosChats from 'src/actions/v2/chats/v2_actionFinalizarMultiplosChats';
import { useSnackbar } from 'notistack';
import { verifyRules } from 'src/utils/functions';
import getActionMensagemLida from 'src/actions/chats/getActionMensagemLida';
import useAuth from 'src/hooks/useAuth';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "src/@/components/ui/accordion";
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Checkbox } from "src/@/components/ui/checkbox";

import { Button } from 'src/@/components/ui/button';

// eslint-disable-next-line no-unused-vars
export default function ChatConversationList({
  cliente,
  isOpenSidebar,
  listaFunilReduce,
  listaTagsReduce,
  listaCanaisReduce,
  tagsSelecionadas,
  funisSelecionadas,
  canaisSelecionados,
  dataFiltered,
  changeTags,
  changeFunis,
  changeCanais,
  expanded,
  changeAccordion,
  limparFiltro,
  isFiltered,
  chatsNaoLidos,
  changeChatsNaoLidos,
  onMoreChats,
  ...other
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { loadingChat } = useSelector((state) => state.chat);
  const [loadingLimparChats, setLoadingLimparChats] = useState(false);
  const [visibleItems, setVisibleItems] = useState(10);
  const listRef = useRef(null);

  // As páginas extras agora vivem em chatsAtendimento (Redux) e já chegam aqui
  // dentro de dataFiltered — o buffer local que existia aqui nunca era populado
  // (seu setter jamais era chamado) e só concatenava um array vazio.
  const mergeChats = dataFiltered || [];

  const loadMoreItems = () => {
    setVisibleItems((prev) => {
      const proximoTotal = prev + 10;
      // Pede a próxima página assim que o usuário alcança o fim do que já está
      // carregado. O gatilho antigo era um passo fixo de 20 a partir de 100,
      // desalinhado do tamanho de página que o backend devolve. Quem calcula o
      // offset é a sidebar, que enxerga a lista crua (dataFiltered já veio
      // filtrado e não serve de offset).
      if (proximoTotal >= mergeChats.length) {
        onMoreChats?.();
      }
      return proximoTotal;
    });
  };

  const scrollPosition = useRef(0);

  // Captura a posição do scroll antes de atualizar a lista
  useLayoutEffect(() => {
    const listElement = listRef.current;
    if (listElement) {
      scrollPosition.current = listElement.scrollTop;
    }
  }, [dataFiltered]);

  // Restaura a posição do scroll logo após a atualização do DOM
  useLayoutEffect(() => {
    const listElement = listRef.current;
    if (listElement && scrollPosition.current !== 0) {
      listElement.scrollTop = scrollPosition.current;
    }
  }, [dataFiltered]);

  const [openModalConfimacao, setOpenModalConfimacao] = useState(false);
  async function limparChats() {
    try {
      let data = {
        usuarioId: user.id,
        status: 'Atendendo',
        clienteId: cliente._id,
      };
      setLoadingLimparChats(true);
      const result = await v2_actionFinalizarMultiplosChats(data);
      if (!result.data.error) {
        dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
        dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
      }
      setLoadingLimparChats(false);
      enqueueSnackbar('Chats finalizados', { variant: 'success' });
    } catch (error) {
      setLoadingLimparChats(false);
      console.log(error);
      enqueueSnackbar('Erro ao limpar chats', { variant: 'error' });
    }
  }

  const handleMarcarNaoLido = (chat) => {
    let dataToUpdade = {
      _id: chat._id,
      scope: {
        novaMensagem: 'sim',
      }
    };
    dispatch(updateChatList(dataToUpdade)); // Atualiza a lista de chats
    getActionMarcarNaoLido({ chatId: chat._id })
  };

  const openWhatsappChat = async (chat) => {
    getActionMensagemLida({ chatId: chat._id });
    dispatch(setChatInfo(chat));
    // Canais de pagina Meta (Instagram/Messenger) usam o endpoint proprio (por
    // instagram_user_id / messenger_user_id). O de WhatsApp busca por numero.
    if (chat.canal === 'instagram') {
      dispatch(getMensagensMetaDb(chat.sessao, chat.instagramUser?.id, 'instagram'));
    } else if (chat.canal === 'messenger') {
      dispatch(getMensagensMetaDb(chat.sessao, chat.messengerUser?.id, 'messenger'));
    } else {
      dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
    }
    let dataToUpdade = {
      _id: chat._id,
      scope: {
        novaMensagem: 'nao'
      }
    };
    dispatch(updateChatList(dataToUpdade)); // Atualiza a lista de chats
    // setTimeout(() => {
    //   dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
    // }, 600);
    dispatch(setSelectedMessage({}));
  };

  return (

    <List ref={listRef}>

      {mergeChats.slice(0, visibleItems).map((chat) => (
        <ChatAtendimentoItem
          disabled={loadingChat ? true : false}
          key={chat._id}
          chat={chat}
          isOpenSidebar={isOpenSidebar}
          onSelectConversation={() => openWhatsappChat(chat)}
          actionMarcarNaoLido={() => handleMarcarNaoLido(chat)}
        />
      ))}

      {visibleItems < mergeChats.length && (
        <Button className="w-full bg-pink-800 hover:bg-violet-600 text-white" onClick={loadMoreItems} fullWidth>
          Carregar Mais
        </Button>
      )}
    </List>

  );
}

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1.5),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 10,
    padding: '4px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  },
}));

const CleanInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1.5),
  },
  '& .MuiInputBase-input': {
    borderRadius: 6,
    position: 'relative',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    fontSize: 14,
    padding: '8px 12px',
    color: '#374151',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      borderColor: '#9ca3af',
    },
    '&:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 1px #3b82f6',
    },
    '&::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
  },
}));

const CompactInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    fontSize: 12,
    padding: '4px 8px',
    color: '#374151',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      borderColor: '#9ca3af',
    },
    '&:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 1px #3b82f6',
    },
    '&::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
  },
}));